import PropTypes from 'prop-types'
import React from 'react'
import moment from 'moment'
import { FormattedMessage } from 'react-intl'
import * as CardStatusRoles from 'const/CardStatusRoles'
import Content from '../../Content'
import ElementContentIcon from '../../ContentIcon'
import {
  ContentHeader,
  ContentIcon,
  ContentTitle,
  ContentBody,
  ContentButton
} from 'components/Content'
import {
  ToggleModal
} from 'components/Modal'
import KanBoIcon from 'components/KanBoIcon'
import Loader from 'components/Loader'
import AddDate from './AddDate'
import StartDate from '../StartDate'
import DueDate from '../DueDate'
import CardDate from '../../CardDate'
import classes from './Dates.module.scss'
import { withBoardPermission } from 'dataProviders/Board'

export class Dates extends React.Component {
  static propTypes = {
    permission: PropTypes.object.isRequired,

    status: PropTypes.object,
    id: PropTypes.number.isRequired,
    isArchived: PropTypes.bool.isRequired,
    dates: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isLoaded: PropTypes.bool.isRequired,

    fetchDates: PropTypes.func.isRequired,
    requestRemoveCustomDate: PropTypes.func.isRequired,
    requestRenameCustomDate: PropTypes.func.isRequired,
    requestChangeCustomDate: PropTypes.func.isRequired,
    requestRemovePersonalDate: PropTypes.func.isRequired,
    requestRenamePersonalDate: PropTypes.func.isRequired,
    requestChangePersonalDate: PropTypes.func.isRequired
  }

  state = {
    nowMoment: moment()
  }

  componentDidMount () {
    const { id, isLoading, isLoaded, fetchDates } = this.props

    if (!isLoading && !isLoaded) {
      fetchDates({
        cardId: id
      })
    }

    this.timer = setInterval(() => {
      this.setState({
        nowMoment: moment()
      })
    }, 10000)
  }

  componentWillUnmount () {
    clearInterval(this.timer)
  }

  hideAddDate = () => {
    this.toggleModalRef.close()
  }

  handleToggleModalRef = (ref) => {
    this.toggleModalRef = ref
  }

  renderAddDate = () => {
    const {
      id
    } = this.props

    return (
      <ToggleModal
        backdrop
        ref={this.handleToggleModalRef}
        attachment='top right'
        targetAttachment='top right'
        constraints={[
          {
            to: 'window',
            pin: true
          }
        ]}
      >
        <ContentButton>
          <ContentIcon>
            <KanBoIcon name='kanbo-16-plus' />
          </ContentIcon>
          <ContentTitle>
            <FormattedMessage id='CARD_DATE_ADD' />
          </ContentTitle>
        </ContentButton>
        <div style={{ width: 300, maxHeight: 300 }}>
          <AddDate
            id={id}
            onDateChange={this.hideAddDate}
          />
        </div>
      </ToggleModal>
    )
  }

  render () {
    const {
      permission,
      status,
      id,
      isArchived,
      dates,
      isLoading,

      requestRemoveCustomDate,
      requestRenameCustomDate,
      requestChangeCustomDate,
      requestRemovePersonalDate,
      requestRenamePersonalDate,
      requestChangePersonalDate
    } = this.props
    const {
      nowMoment
    } = this.state

    return (
      <Content>
        <ContentHeader>
          <ElementContentIcon>
            <KanBoIcon name='kanbo-24-calendar' />
          </ElementContentIcon>
          <ContentTitle>
            <FormattedMessage id='CARD_DATES' />
          </ContentTitle>
        </ContentHeader>
        <ContentBody className={classes.datesContainer}>
          {isLoading &&
            <Loader center />
          }
          {dates.map(date => {
            const onRemove =
              date.isPersonal
                ? () => requestRemovePersonalDate({ id: date.id })
                : () => requestRemoveCustomDate({ cardId: id, dateId: date.id })

            const onNameChange =
              date.isPersonal
                ? (name) => requestRenamePersonalDate({ id: date.id, name })
                : (name) => requestRenameCustomDate({ cardId: id, dateId: date.id, name })

            const onDateChange =
              date.isPersonal
                ? (timestamp) => requestChangePersonalDate({ id: date.id, timestamp })
                : (timestamp) => requestChangeCustomDate({ cardId: id, dateId: date.id, timestamp })

            if (date.isDueDate) {
              return (
                <DueDate />
              )
            } else if (date.isStartDate) {
              return (
                <StartDate />
              )
            } else {
              let dateStyle = undefined

              if (
                status
                  ? (
                    status.role !== CardStatusRoles.NONE &&
                    status.role !== CardStatusRoles.COMPLETED
                  )
                  : false
              ) {
                if (moment(date.timestamp).isSameOrBefore(nowMoment)) {
                  dateStyle = 'danger'
                } else if (moment(date.timestamp).diff(nowMoment, 'days') <= 7) {
                  dateStyle = 'warning'
                }
              }

              return (
                <CardDate
                  key={date.id}
                  icon={<KanBoIcon name={date.isPersonal ? 'kanbo-16-personal-reminder' : 'kanbo-16-card-date'} />}
                  id={date.id}
                  name={date.name}
                  style={dateStyle}
                  date={date.timestamp}
                  onRemove={onRemove}
                  editableName
                  onNameChange={onNameChange}
                  onDateChange={onDateChange}
                />
              )
            }
          })}
        </ContentBody>
        {(!isArchived && permission.member) &&
          this.renderAddDate()
        }
      </Content>
    )
  }
}

export default withBoardPermission(Dates)
